"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _async = _interopRequireDefault(require("react-select/async"));

var _dropdown = require("../dropdown");

var _excluded = ["width", "tag", "selectRef", "components", "asyncMode", "isSearchable", "isLinked", "smallOption", "dataTest"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select = function Select(_ref) {
  var width = _ref.width,
      tag = _ref.tag,
      selectRef = _ref.selectRef,
      components = _ref.components,
      asyncMode = _ref.asyncMode,
      isSearchable = _ref.isSearchable,
      isLinked = _ref.isLinked,
      smallOption = _ref.smallOption,
      dataTest = _ref.dataTest,
      rest = _objectWithoutProperties(_ref, _excluded);

  var SelectComponent = asyncMode ? _async["default"] : _reactSelect["default"];
  var SelectOption = isLinked ? _dropdown.OptionLinked : smallOption ? _dropdown.SmallOption : _dropdown.Option;
  return /*#__PURE__*/_react["default"].createElement(_dropdown.Container, {
    as: tag,
    width: width,
    isSearchable: isSearchable,
    "data-test": dataTest,
    id: "id-1"
  }, /*#__PURE__*/_react["default"].createElement(SelectComponent, _extends({
    ref: selectRef,
    isSearchable: isSearchable,
    styles: _dropdown.customStyles,
    components: _objectSpread({
      IndicatorSeparator: null,
      Control: _dropdown.Control,
      Option: SelectOption,
      Menu: _dropdown.Menu,
      MenuList: _dropdown.MenuList,
      DropdownIndicator: _dropdown.DropdownIndicator,
      ClearIndicator: _dropdown.ClearIndicator
    }, components)
  }, rest)));
};

Select.propTypes = {
  width: _propTypes["default"].string,
  components: _propTypes["default"].object,
  asyncMode: _propTypes["default"].bool,
  isSearchable: _propTypes["default"].bool,
  smallOption: _propTypes["default"].bool
};
Select.defaultProps = {
  isSearchable: false
};
var _default = Select;
exports["default"] = _default;